import { css } from '@emotion/css';
import { colors } from '@/colors';

import IconInfo from '@/assets/Icon/svg/InfoFilled';
import IconSuccess from '@/assets/Icon/svg/SuccessFilled';
import IconWarning from '@/assets/Icon/svg/WarningFilled';
import IconError from '@/assets/Icon/svg/ErrorFilled';

export const getAlertStyles = (type) => {
  switch (type) {
    case 'info':
      return {
        background: colors.AJAIB_BLUE_1,
        border: colors.AJAIB_BLUE_2,
        textColor: colors.AJAIB_BLUE_6,
        iconColor: colors.AJAIB_BLUE_6,
        icon: IconInfo,
        backgroundHover: colors.AJAIB_BLUE_2,
      };
    case 'success':
      return {
        background: colors.GREEN_1,
        border: colors.GREEN_5,
        textColor: colors.GREEN_5,
        iconColor: colors.GREEN_5,
        icon: IconSuccess,
        backgroundHover: colors.GREEN_3,
      };
    case 'caution':
      return {
        background: colors.YELLOW_1,
        border: colors.YELLOW_3,
        textColor: colors.YELLOW_6,
        iconColor: colors.YELLOW_6,
        icon: IconWarning,
        backgroundHover: colors.YELLOW_3,
      };
    case 'error':
      return {
        background: colors.RED_1,
        border: colors.RED_6,
        textColor: colors.RED_6,
        iconColor: colors.RED_6,
        icon: IconError,
        backgroundHover: colors.RED_3,
      };
    case 'default':
    default:
      return {
        background: colors.NEUTRAL_0,
        border: colors.NEUTRAL_0,
        textColor: colors.NEUTRAL_10,
        iconColor: colors.AJAIB_BLUE_5,
        icon: IconInfo,
        backgroundHover: colors.AJAIB_BLUE_1,
      };
  }
};

export const styMessageBox = ({ type, icon, withArrowTip }) => css`
  position: relative;
  padding: 16px;
  background-color: ${getAlertStyles(type).background};
  border: 1px solid ${getAlertStyles(type).border};
  border-radius: 8px;
  overflow: hidden;
  ${type === 'default' && 'box-shadow: 0px 4px 8px rgba(51, 51, 51, 0.08);'}

  ${icon &&
  `
    > :first-child > :first-child {
      align-self: baseline;
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    > :not(:first-child) > :first-child {
      margin-left: 24px;
    }
  `}
  ${withArrowTip &&
  `
    &:before {
      content: '';
      position: absolute;
      top: -11px;
      right: 32px;
      width: 20px;
      height: 20px;
      background: ${getAlertStyles(type).background};
      border-top: 1px solid ${getAlertStyles(type).border};
      border-left: 1px solid ${getAlertStyles(type).border};
      transform: rotate(45deg);
    }
  `}
`;

export const styBtnClose = ({ type }) => css`
  display: flex;
  align-self: baseline;
  box-sizing: border-box;

  background: transparent;
  width: 20px;
  height: 20px;
  padding: 4px !important;
  border: 0;
  border-radius: 4px;
  cursor: pointer;

  :hover,
  :active {
    background: ${getAlertStyles(type).backgroundHover};
  }
`;

export const styTitle = ({ textColor, type }) => css`
  display: block;
  margin: 0;
  margin-bottom: 4px;

  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 22px;
  color: ${textColor || getAlertStyles(type).textColor};
  text-align: left;
`;

export const styDescription = ({ textColor, type }) => css`
  display: block;
  margin: 0;

  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  color: ${textColor || getAlertStyles(type).textColor};
  text-align: left;
`;

export const styActionBtn = () => css`
  display: block;
  background: transparent;
  padding: 2px 4px;
  margin: -2px -4px;
  border: none;

  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${colors.AJAIB_BLUE_5};
  cursor: pointer;

  :hover,
  :active {
    color: ${colors.AJAIB_BLUE_7};
  }
`;
